import { Stack, Box, Text, ThemeIcon, Collapse } from "@mantine/core";
import { NavLink as RouterNavLink } from "react-router-dom";
import React, { useState } from "react";
import {
    IconHome,
    IconSchool,
    IconInvoice,
    IconUsers,
    IconCertificate,
    IconClipboardList,
    IconTable,
    IconChevronDown,
    IconChevronUp,
    IconPackageImport,
    IconRocket,
    IconVideo,
    IconGift,
} from "@tabler/icons-react";
import { isCurrentUserBatchOnly } from "../auth/batchOnlyAccess";

export default function Navigation({ onLinkClick = () => {} }) {
    const [tablesOpened, setTablesOpened] = useState(false);
    const batchOnly = isCurrentUserBatchOnly();

    // Table items for dropdown
    const tableItems = [
        { label: "Access Codes", path: "/tables/access-codes" },
        { label: "Videos", path: "/tables/videos" },
        { label: "Instructor", path: "/tables/instructor" },
        { label: "Tags", path: "/tables/tags" },
    ];

    // Main navigation items (reordered)
    const allBatchesItem: { label: string; icon: typeof IconSchool; path: string; color?: string } = {
        label: "All Batches",
        icon: IconSchool,
        path: "/Batches",
        color: "#f5576c",
    };

    // Batch-only accounts (see REACT_APP_BATCH_ONLY_EMAILS) only ever get
    // the All Batches module — everything else stays hidden from the nav.
    const menuItems = batchOnly
        ? [allBatchesItem]
        : [
        {
            label: "Certification",
            icon: IconCertificate,
            path: "/Certification",
            color: "#06b6d4",
        },
         // {
        //     label: "Remittance",
        //     icon: IconReportMoney,
        //     path: "/Remittance",
        //     color: "#8b5cf6",
        // },
        {
            label: "All Invoices",
            icon: IconInvoice,
            path: "/Invoice",
            color: "#ffc107",
        },
        {
            label: "All MOU",
            path: "/allmou",
            icon: IconInvoice,
        },
        allBatchesItem,
        {
            label: "Students",
            icon: IconUsers,
            path: "/Students",
            color: "#10b981",
        },
        // {
        //     label: "Attendance",
        //     icon: IconClipboardList,
        //     path: "/Attendance",
        //     color: "#fb923c",
        // },
        {
          label:"Package",
          icon:IconPackageImport,
          path:"/Package",
          color:"#fb923c",
        },

                {
          label: "Trainer Referral",
          icon: IconGift,
          path: "/trainer-referral",
          color: "#14b8a6",
        },


         {
          label: "Recording Tracker",
          icon: IconGift,
          path: "/recording-tracker",
          color: "#14b8a6",
        },


        {
          label: "Admin management",
          icon: IconGift,
          path: "/admin-management",
          color: "#14b8a6",
        },



        {
          label:"Batch Sessions",
          icon:IconVideo,
          path:"/batch-sessions",
          color:"#8b5cf6",
        }
    ];

    const renderMenuIcon = (Icon:any, isActive:boolean, color?:string) => (
        <ThemeIcon
            variant={isActive ? "filled" : "light"}
            size="sm"
            radius="md"
            style={{
                backgroundColor: isActive ? color || "#667eea" : "#f3f4f6",
                color: isActive ? "#ffffff" : color || "#6b7280",
            }}
        >
            <Icon size={16} stroke={1.5} />
        </ThemeIcon>
    );

    return (
        <Stack gap="6px">
          {/* Task Pilot - External Link */}
          {!batchOnly && (
          <>
            <Box
                onClick={() => {
                    window.open("https://task-pilot-agbx.onrender.com", "_blank");
                    onLinkClick();
                }}
                style={{
                    padding: "10px 12px",
                    borderRadius: "6px",
                    backgroundColor: "#eff6ff",
                    borderLeft: "3px solid #2563eb",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    border: "1px solid #bfdbfe",
                }}
                className="hover:bg-blue-100"
            >
                {renderMenuIcon(IconRocket, true, "#2563eb")}
                <Box style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Text
                        size="sm"
                        fw={600}
                        style={{
                            color: "#2563eb",
                        }}
                    >
                        Task Pilot
                    </Text>
                    <Box
                        style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            backgroundColor: "#2563eb",
                        }}
                    />
                </Box>
            </Box>

            {/* Dashboard */}
            <RouterNavLink
                to="/dashboard"
                style={{ textDecoration: "none" }}
                onClick={onLinkClick}
            >
                {({ isActive }) => (
                    <Box
                        style={{
                            padding: "10px 12px",
                            borderRadius: "6px",
                            backgroundColor: isActive ? "#fef2f4" : "transparent",
                            borderLeft: isActive ? "3px solid #f5576c" : "3px solid transparent",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                        }}
                        className="hover:bg-gray-50"
                    >
                        {renderMenuIcon(IconHome, isActive, "#667eea")}
                        <Text
                            size="sm"
                            fw={isActive ? 600 : 500}
                            style={{ color: isActive ? "#1f2937" : "#6b7280" }}
                        >
                            Dashboard
                        </Text>
                    </Box>
                )}
            </RouterNavLink>
          {/* Tables Dropdown (just below Dashboard) */}
<Box>
  <Box
    onClick={() => setTablesOpened((prev) => !prev)}
    style={{
      padding: "10px 12px",
      borderRadius: "6px",
      backgroundColor: tablesOpened ? "#fef2f4" : "transparent",
      borderLeft: tablesOpened ? "3px solid #f5576c" : "3px solid transparent",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
    className="hover:bg-gray-50"
  >
    {renderMenuIcon(IconTable, tablesOpened, "#ec4899")}
    <Box style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Text
        size="sm"
        fw={tablesOpened ? 600 : 500}
        style={{
          color: tablesOpened ? "#1f2937" : "#6b7280",
        }}
      >
        Tables
      </Text>
      {tablesOpened ? (
        <IconChevronUp size={16} style={{ color: "#6b7280" }} />
      ) : (
        <IconChevronDown size={16} style={{ color: "#6b7280" }} />
      )}
    </Box>
  </Box>

  <Collapse in={tablesOpened}>
    <Stack gap="2px" style={{ marginTop: "4px", paddingLeft: "12px" }}>
      {tableItems.map((table) => (
        <RouterNavLink
          key={table.label}
          to={table.path}
          style={{ textDecoration: "none" }}
          onClick={() => {
            onLinkClick();        //  Close sidebar
            setTablesOpened(false); //  Also collapse the Tables menu
          }}
        >
          {({ isActive }) => (
            <Box
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                backgroundColor: isActive ? "#fef2f4" : "transparent",
                borderLeft: isActive ? "2px solid #ec4899" : "2px solid transparent",
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              className="hover:bg-gray-50"
            >
              <Box
                style={{
                  width: "4px",
                  height: "4px",
                  borderRadius: "50%",
                  backgroundColor: isActive ? "#ec4899" : "#d1d5db",
                }}
              />
              <Text
                size="xs"
                fw={isActive ? 600 : 500}
                style={{
                  color: isActive ? "#1f2937" : "#6b7280",
                }}
              >
                {table.label}
              </Text>
            </Box>
          )}
        </RouterNavLink>
      ))}
    </Stack>
  </Collapse>
</Box>
          </>
          )}

            {/* Rest of the menu */}
            {menuItems.map((item) => (
                <RouterNavLink
                    key={item.label}
                    to={item.path}
                    style={{ textDecoration: "none" }}
                    onClick={onLinkClick}
                >
                    {({ isActive }) => (
                        <Box
                            style={{
                                padding: "10px 12px",
                                borderRadius: "6px",
                                backgroundColor: isActive ? "#fef2f4" : "transparent",
                                borderLeft: isActive ? "3px solid #f5576c" : "3px solid transparent",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                            className="hover:bg-gray-50"
                        >
                            {renderMenuIcon(item.icon, isActive, item.color)}
                            <Box style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Text
                                    size="sm"
                                    fw={isActive ? 600 : 500}
                                    style={{
                                        color: isActive ? "#1f2937" : "#6b7280",
                                    }}
                                >
                                    {item.label}
                                </Text>
                                {isActive && (
                                    <Box
                                        style={{
                                            width: "6px",
                                            height: "6px",
                                            borderRadius: "50%",
                                            backgroundColor: "#f5576c",
                                        }}
                                    />
                                )}
                            </Box>
                        </Box>
                    )}
                </RouterNavLink>
            ))}
        </Stack>
    );
}